import { Skeleton } from '@/components/ui/skeleton';

export function StatusHistoryChartSkeleton() {
  const totalCount = 60;

  type FullWidthClasses = {
    [index: number]: string;
  };

  const fullWidthClasses: FullWidthClasses = {
    60: 'w-1/78',
    90: 'w-1/115',
  };

  return (
    <>
      <div className="@container flex justify-between">
        {Array.from({ length: totalCount }).map((_, index) => (
          <Skeleton
            key={index}
            className={`@max-xl:w-1/60 @max-md:w-1/38 @max-2xs:w-1/19 ${fullWidthClasses[totalCount]} animate-pulse-slow aspect-2/7 rounded-lg bg-gray-300 ${index < totalCount - 45 ? '@max-xl:hidden' : ''} ${index < totalCount - 30 ? '@max-md:hidden' : ''} ${index < totalCount - 15 ? '@max-2xs:hidden' : ''}`}
            style={{ animationDelay: `${index * 50}ms` }}
          />
        ))}
      </div>
      <div className="@container mt-2 flex justify-between text-xs text-gray-500">
        <Skeleton>
          <span className="invisible">15d ago</span>
        </Skeleton>
        <Skeleton>
          <span className="invisible">Today</span>
        </Skeleton>
      </div>
    </>
  );
}
